import { Navigate } from 'react-router-dom';

function AdminRoute({children}) {
    const isAuth = localStorage.getItem("token") || undefined;
    const role = localStorage.getItem("role") || undefined;
    return isAuth && (role === "admin" || role === "manager" || role === "producer") ? children : <><Navigate to="/login" /></> ;
}

export default AdminRoute